import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Input, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { CellClickedEvent, ColDef, GridReadyEvent } from 'ag-grid-community';
import { Observable, catchError, of, tap } from 'rxjs';
import DashboardSearchCriteria from 'src/app/interfaces/dashboardSearchCriteria';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { AuthenticationService } from 'src/app/services/authentication.service';
import {DateTime} from 'luxon';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import RenderDriverReportRequest from 'src/app/interfaces/renderReportRequest';
import { DriverReportView } from 'src/app/interfaces/driverReportView';
import { RecordsService } from 'src/app/services/records.service';
import { DriverDashboardRecord } from 'src/app/interfaces/driverDashboardRecord';
import { CelllinkrendererComponent } from '../cellrenderers/celllinkrenderer/celllinkrenderer/celllinkrenderer.component';
import { CustomercellbuttonrendererComponent } from '../cellrenderers/customercellbuttonrenderer/customercellbuttonrenderer/customercellbuttonrenderer.component';
import { DriverRecordRequestService } from 'src/app/services/driverrecordrequest.service';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AuditService } from 'src/app/services/audit.service';
import { TranslatorService } from 'src/app/services/translator.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
    selector: 'app-dashboardgrid',
    templateUrl: './dashboardgrid.component.html',
    styleUrls: ['./dashboardgrid.component.scss'],
    standalone: false
})
export class DashboardgridComponent {
    @Input() searchCriteria: DashboardSearchCriteria = { searchString: '', pageSize: 10 };
    oldSearchCriteria: DashboardSearchCriteria = { searchString: '', pageSize: 10 };
    columnDefs: [] | any = [];
    useMockData: boolean = false;
    startRow: number = 1;
    pageSize: number = 8000;
    sortCol: string = 'RequestDate';
    sortDir: string = 'desc';
    gridOptions: any = {};
    defaultColDef: any = {
        resizable: true,
        debug: true,
        rowSelection: 'multiple',
        paginationAutoPageSize: true,
        pagination: true,
        wrapText: true
    };
    frameworkComponents: any;
    loadingCellRenderer: any;
    loadingCellRendererParams: any;
    overlayLoadingTemplate: any;
    overlayNoRowsTemplate: any;
    domLayout: any;
    colResizeDefault: any;
    voodooComplete: boolean = false;
    gridLanguage: string = '';
    cacheOverflowSize = 2;
    maxConcurrentDatasourceRequests = 2;
    maxBlocksInCache = 2;
    paginationPageSize = 10;
    cacheBlockSize = 10;
    showProbationModal: boolean = false;
    showPendingUnderReviewModal: boolean = false;
    isSubmitStatus: boolean = false;
    isResubmitStatus: boolean = false;
    probationButtonText: string = '';
    coversheetType: string = '';
    isLoading: boolean = true;
    currentAuthCode: string = '';
    isIahCustomer: boolean = false;
    showUploadModal: boolean = false;
    currentTrans: any = {
        authCode: '', 
        probationStatusId: '', 
        documentId: '', 
        firstName: '', 
        lastName: '', 
        requestDate: ''
    };
    isUploading: boolean = false;
    username: string = '';
    userProfile: UserProfile | undefined;
    pdfUrl: string = '';
    probationDocuments: any = [];
    isResubmit: boolean = false;
    isValidFileType: boolean = true;
    authMethod: string = 'Login.gov';
    accessedVia: string = 'CustomerDashboard';
    customerId: string = '';
    gridData: any = {};
    rowData$: DriverDashboardRecord[] = [];
    doCheckCount: number = 0;
    lang: string = '';
    loadingText: string = '';
    noRowsText: string = '';
    invFileTypeModal: any;
    requestedByHeader: string = '';
    requestDateHeader: string = '';
     lastNameHeader: string = '';
     licenseNumberHeader: string = '';
     stateHeader: string = '';
     actionsHeader: string = '';
     viewButtonText: string = '';
     expiredText: string = '';
     downloadButtonText: string = '';
     submitButtonText: string = '';
     resubmitButtonText: string = '';
     pendingButtonText: string = '';
     underReviewButtonText: string = '';

    @ViewChild('SubmitOrResubmitModal')
    submitOrResubmitModal!: TemplateRef<any>;

    @ViewChild('UploadModal')
    uploadModal!: TemplateRef<any>;

    @ViewChild('InvalidFileTypeModal')
    invalidFileTypeModal!: TemplateRef<any>;

    @ViewChild('PendingUnderReviewModal')
    pendingUnderReviewModal!: TemplateRef<any>;

    @ViewChild('pageVooDoo') 
    footerArea: ElementRef | undefined;

    constructor(
      private http: HttpClient, 
      private authenticationService: AuthenticationService,
      public router: Router,
      private recordsService: RecordsService,
      public driverRecordRequestService: DriverRecordRequestService,
      private modalService: NgbModal,
      private auditService: AuditService,
      public translationService: TranslatorService,
      public generalService: GeneralService) 
      {
        // get customer type before calling getColumnDefs
        this.userProfile = this.authenticationService.getUserProfile() as UserProfile;
        this.isIahCustomer = (this.userProfile.customerType === 2);
        this.customerId = this.userProfile!.customerId;

        this.getColumnDefs().then((r) => this.loadColumnDefs(r));
        this.lang = this.translationService.getActiveLanguage().toUpperCase();
        this.updateTranslatedText(this);

        this.overlayLoadingTemplate = `<span class="ag-overlay-loading-center">${this.loadingText}</span>`;
        this.overlayNoRowsTemplate = `<span><em>${this.noRowsText}</em></span>`;
        this.domLayout = 'autoHeight';
        this.defaultColDef = { resizable: true };
      }

          // ********************** Lifecycle Events ********************** //
    ngOnInit(): void {
        //detect language change
        this.translationService._hasChanges$.subscribe(newValue => {
            if (newValue === true) {
                 this.translationService.restHasChange();
                 this.lang = this.translationService.getActiveLanguage().toUpperCase();
                 this.refreshGrid(this);
            }else{
                this.refreshGrid(this);
            }
       });

        this.username = this.authenticationService.getUserName();
        this.gridOptions.gridApi = this.gridOptions.api;
        this.gridOptions.gridColumnApi = this.gridOptions.columnApi;
        this.gridLanguage = this.translationService.getActiveLanguage().toUpperCase();;
        this.getColumnDefs().then((r) => this.loadColumnDefs(r));
    }

    ngDoCheck() {
        this.doCheckCount++;
        if (this.searchCriteria.searchString !== this.oldSearchCriteria.searchString || this.searchCriteria.pageSize !== this.oldSearchCriteria.pageSize ) {
            this.oldSearchCriteria = Object.assign({}, this.searchCriteria);
            this.gridOptions.api.paginationSetPageSize(Number(this.searchCriteria.pageSize));
            this.refreshGrid(this);
        }
    }

    get currentTransaction() {
        return this.currentTrans;
    }

    fileNamesDisplay() {
        if (this.probationDocuments.length > 0) {
            const separator = ', ';
            let display = this.probationDocuments[0].fileName;
            for (let index = 0; index < this.probationDocuments.length - 1; index++) {
                if (index > 0) {
                    display = display.concat(separator, this.probationDocuments[index].fileName)
                }
            }
        }
    }

    loadColumnDefs(r: any) {
        if (r !== undefined) {
            this.columnDefs = r;
        }
    }

    refreshGrid(scope: any) {
        this.isLoading = true;
        this.recordsService.getAccountHolderRecordsObservable(1, 8000, 'RequestDate', 'desc', '', this.searchCriteria.searchString)
        .subscribe((response: any) => {
            this.rowData$ = response.items as DriverDashboardRecord[];
            this.smartSizeColumns();
            this.isLoading = false;
        });

        this.getColumnDefs().then((r) => this.loadColumnDefs(r));

        this.lang = this.translationService.getActiveLanguage().toUpperCase();;
        this.updateTranslatedText(this);

        this.overlayLoadingTemplate = `<span class="ag-overlay-loading-center">${this.loadingText}</span>`;
        this.overlayNoRowsTemplate = `<span><em>${this.noRowsText}</em></span>`;
        this.domLayout = 'autoHeight';
        this.defaultColDef = { resizable: true };
        setTimeout(function () {
            scope.smartSizeColumns();
        }, 2000);
        
        this.isLoading = false;
    }

    onGridReady(params: any) {
        
        this.recordsService.getAccountHolderRecordsObservable(1, 8000, 'RequestDate', 'desc', '', this.searchCriteria.searchString)
        .subscribe((response: any) => {
            this.rowData$ = response.items as DriverDashboardRecord[];
            this.smartSizeColumns();
        });
    }

    onSelectionChanged() {
        const selectedRows = this.gridOptions.api.getSelectedRows();
        //this.$emit('selected', selectedRows[0].cdbCustomerId);
    }

    // ********************** Grid Data ********************** //
    rowData: any = {
        getRows: (params: any) => {
            this.populateRecords(
                params.startRow / this.pageSize + 1,
                this.pageSize,
                this.sortCol,
                this.sortDir
            );
        }
    }

    populateRecords(
        pageNumber: number,
        itemsPerPage: number,
        sortColumn: string,
        sortDir: string
    ) {
        if (this.useMockData) {
            // const records = recordsService.getMockRecords(
            //     pageNumber,
            //     itemsPerPage,
            //     sortColumn,
            //     sortDir
            // );
            // this.rowData = records!.items;
            // return this.rowData;
        } else {
            const recordsPromise = this.recordsService.getAccountHolderRecords(pageNumber, itemsPerPage, sortColumn, sortDir, this.username, '');
            recordsPromise
                .then((response: any) => {
                    this.rowData = [];
                    if (response) {
                        this.gridData = response;
                        this.rowData = response!.items;
                        this.isLoading = false;
                        return this.rowData;
                    }
                })
                .catch((error: any) => {
                    console.error(error);
                    this.rowData = [];
                    this.isLoading = false;
                    return this.rowData;
                });
        }
    }

    async getColumnDefs() {
        const pageScope = this;
        pageScope.updateTranslatedText(pageScope);
        const promise = new Promise((resolve, reject) => {

            const expired: DateTime = DateTime.now()
                .minus({ hours: Number(environment.APP_DRIVER_RECORD_EXPIRATION_HOURS) })
                .endOf('hour');
                
            const isIahCustomer: boolean = this.isIahCustomer;
            let records = [
                {
                    headerName: pageScope.requestDateHeader,
                    field: 'requestDate',
                    valueFormatter: (params: any) => this.formatDate(params),
                    sortable: true,
                    minWidth: 155,
                    maxWidth: 180,
                    flex: 2,
                },
                {
                    headerName: pageScope.lastNameHeader,
                    field: 'lastName',
                    sortable: true,
                    minWidth: 110,
                    flex: 2, 
                    resizable: true,
                    suppressSizeToFit: false,
                    cellRenderer: CelllinkrendererComponent,
                    cellRendererParams: {
                        hoverText: pageScope.viewButtonText,
                        linkClass: '',
                        hideLink: function (params: any) {
                             return params!.data!.probationStatusId != null && params!.data!.probationStatusId !== '3'
                        },
                        linkName: function (params: any) { return 'view_' + params!.data!.authCode; },
                        callback: function (celLValue: string, authCode: string, driversConsent: boolean) {
                            try {
                                const componentScope = pageScope;
                                if (driversConsent === false) {
                                    pageScope.router.navigateByUrl(`/byAuthCode/${authCode}`);
                                } else {
                                    const request: RenderDriverReportRequest = { asPdf: false, authCode: authCode, driverIP: '' };
                                    componentScope.driverRecordRequestService.getEndUserIp()
                                        .then((result: any) => {
                                            request.driverIP = result;
                                            const reportView: DriverReportView = {
                                                accessedVia: componentScope.accessedVia,
                                                accessedBy: componentScope.username,
                                                accessorCustomerId: componentScope.customerId,
                                                authCode: authCode,
                                                authenticationMethod: componentScope.authMethod, 
                                                accessedDateTime: DateTime.now().toJSDate()
                                            } 
                                            componentScope.driverRecordRequestService.openDriverReport(request, reportView)
                                                .then((v: string | any) => {
                                                    componentScope.openInBrowser(v);
                                                })
                                                .catch((error: any) => {
                                                    console.error(error);
                                                });
                                        }).catch((error: any) => {
                                            console.error(error);
                                            const reportView: DriverReportView = {
                                                accessedVia: componentScope.accessedVia,
                                                accessedBy: componentScope.username,
                                                accessorCustomerId: componentScope.customerId,
                                                authCode: authCode,
                                                authenticationMethod: componentScope.authMethod, 
                                                accessedDateTime: DateTime.now().toJSDate()
                                            }
                                            componentScope.driverRecordRequestService.openDriverReport(request, reportView)
                                                .then((v: string | any) => {
                                                    const reportView: DriverReportView = {
                                                        accessedVia: componentScope.accessedVia,
                                                        accessedBy: componentScope.username,
                                                        accessorCustomerId: componentScope.customerId,
                                                        authCode: authCode,
                                                        authenticationMethod: componentScope.authMethod, 
                                                        accessedDateTime: DateTime.now().toJSDate()
                                                    } 
                                                    componentScope.openInBrowser(v);
                                                })
                                                .catch((error: any) => {
                                                    console.error(error);
                                                });
                                        });
                                }
                                
                            } catch (error) {
                                console.error(error);
                            }
                        }
                    }
                },
                {
                    headerName: pageScope.licenseNumberHeader,
                    field: 'driverLicenseNumber',
                    tooltipField: 'driverLicenseNumber',
                    sortable: true,
                    minWidth: 100,
                    flex: 2,
                    resizable: true,
                },
                {
                    headerName: pageScope.stateHeader,
                    field: 'driverLicenseState',
                    tooltipField: 'driverLicenseState',
                    sortable: true,
                    minWidth: 85,
                    maxWidth: 85,
                    flex: 2,
                },
                {
                    headerName: pageScope.requestedByHeader,
                    field: 'userName',
                    tooltipField: 'userName',
                    sortable: true,
                    minWidth: 135,
                    flex: 2,
                    resizable: true,
                },
                {
                    headerName: pageScope.actionsHeader,
                    field: 'authCode',
                    sortable: false,
                    minWidth: 210,
                    maxWidth: 210,                    
                    flex: 2,
                    suppressSizeToFit: false,
                    cellRenderer: CustomercellbuttonrendererComponent,
                    cellRendererParams: {
                        buttonText: pageScope.downloadButtonText,
                        buttonClass: 'btn btn-primary btn-sm mt-n1',
                        buttonIcon: '',
                        hideButton: function (probationStatusId: string, requestDate: string) {
                            if (probationStatusId != null && probationStatusId !== '3') {
                                /* HIDE BUTTON if: is on probation and transaction is NOT approved */
                                return true;
                            }
                            else if (DateTime.fromFormat(requestDate, 'YYYY-MM-DDTHH:mm:ss') < expired) {
                                /* HIDE BUTTON if: transaction is expired */
                                return true;
                            } else {
                                /* SHOW BUTTON if: is on probation and transaction IS approved OR not on probation */
                                return false;
                            }
                        },
                        buttonName: function (authCode: string) {
                            return 'download_' + authCode;
                        },
                        hideButtonText: '',
                        function (params: any) {
                            return 'download_' + params.data.authCode;
                        },
                        callback: function (authCode: string, driversConsent: boolean) {
                            if (driversConsent === false) {
                                pageScope.router.navigateByUrl(`/byAuthCode/${authCode}`);
                            } else {
                                /* Get report */
                                const componentScope = pageScope;
                                const reportView: DriverReportView = {
                                    accessedVia: componentScope.accessedVia,
                                    accessedBy: componentScope.username,
                                    accessorCustomerId: componentScope.customerId,
                                    authCode: authCode,
                                    authenticationMethod: componentScope.authMethod, 
                                    accessedDateTime: DateTime.now().toJSDate()
                                } 
                                pageScope.driverRecordRequestService.getDriverReportPdf(authCode, reportView)
                                .then((v: any) => componentScope.openPdf(v))
                                .catch((error: any) => {
                                    console.error(error);
                                });
                            }
                        },
                        
                        isIahCustomer: isIahCustomer,
                        probationSubmitButtonText: pageScope.submitButtonText,
                        probationResubmitButtonText: pageScope.resubmitButtonText,
                        probationPendingButtonText: pageScope.pendingButtonText,
                        probationUnderReviewButtonText: pageScope.underReviewButtonText,
                        probationButtonClass: 'btn btn-primary btn-sm mt-n1',
                        probationButtonIcon: '',
                        hideProbationButton: function (params: any) {
                            /* SHOW BUTTON if: is on probation and transaction is NOT approved */
                            return (params!.data!.probationStatusId !== null && params!.data!.probationStatusId !== '3') ? false : true;
                        },
                        probationButtonName: function (params: any) {
                            return 'probation_' + params.data.authCode;
                        },
                        nameProbationButton: function (params: any) {
                            if (params!.data!.probationStatusId === null) return;
                            switch (params!.data!.probationStatusId) {
                                case '1': {
                                    if (params!.data!.documentId === null) {
                                        /* show submit button */
                                        return params!.probationSubmitButtonText;
                                    } else {
                                        /* show under review button */
                                        return params!.probationUnderReviewButtonText;
                                    }
                                    break;
                                }
                                case '2': {
                                    /* show resubmit button */
                                    return params!.probationResubmitButtonText;
                                    break;
                                }
                                case '4': {
                                    /* show resubmit button */
                                    return params!.probationResubmitButtonText;
                                    break;
                                }
                            }
                        },
                        probationButtonCallback: function (authCode: string, probationStatusId: string, documentId: string, firstName: string, lastName: string, requestDate: string) {
                            // Store current transaction data
                            const componentScope = pageScope;
                            componentScope.currentAuthCode = authCode;
                            componentScope.currentTrans!.authCode = authCode;
                            componentScope.currentTrans!.probationStatusId = probationStatusId;
                            componentScope.currentTrans!.documentId = documentId;
                            componentScope.currentTrans!.firstName = firstName;
                            componentScope.currentTrans!.lastName = lastName;
                            componentScope.currentTrans!.requestDate = requestDate;

                            if (this.isIahCustomer && probationStatusId !== '3') {
                                /* Go to IAH consent page */
                                const url: string = `${environment.APP_PSP_BASE_URL}/byAuthCode/${authCode}`;
                                window.location.href = url;
                            } else {
                                switch (probationStatusId) {
                                    case '1': {
                                        if (documentId === null) {
                                            componentScope.isSubmitStatus = true;
                                            componentScope.probationButtonText = this.probationSubmitButtonText;
                                            componentScope.modalService.open(componentScope.submitOrResubmitModal, { ariaLabelledBy: 'submitOrResubmitModalTitle' });
                                        } else {
                                            componentScope.showPendingUnderReviewModal = true;
                                            componentScope.probationButtonText = this.probationResubmitButtonText;
                                            componentScope.modalService.open(componentScope.pendingUnderReviewModal, { ariaLabelledBy: 'pendingUnderReviewModalTitle' });
                                        }
                                        break;
                                    }
                                    case '2': {
                                        componentScope.isResubmit = true;
                                        componentScope.isResubmitStatus = true;
                                        componentScope.probationButtonText = this.probationResubmitButtonText;
                                        componentScope.modalService.open(componentScope.submitOrResubmitModal, { ariaLabelledBy: 'submitOrResubmitModalTitle' });
                                        break;
                                    }
                                    case '4': {
                                        componentScope.isResubmit = true;
                                        componentScope.isResubmitStatus = true;
                                        componentScope.probationButtonText = this.probationResubmitButtonText;
                                        componentScope.modalService.open(componentScope.submitOrResubmitModal, { ariaLabelledBy: 'submitOrResubmitModalTitle' });
                                        break;
                                    }
                                }
                            }
                        },
                    }
                },
            ];
            resolve(records);
        });
        return await promise;
    }

    openPdf(buffer: any) {
        const filename = "DriverReport.pdf";
        const element = document.createElement('a');
        element.setAttribute('href', 'data:application/pdf;base64,' + buffer);
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    cleanModel(){
        const voodoo = null; 
        if(voodoo){
            const document:Document = (voodoo as HTMLElement).ownerDocument;
            const agUnselectableClassed: NodeListOf<HTMLElement> = document.querySelectorAll('.ag-body-horizontal-scroll, .ag-overlay');
            agUnselectableClassed.forEach((el: HTMLElement) => {
                el.removeAttribute('aria-hidden')
            });
        }
    }

    // ********************** Open Driver Reports ********************** //
    openInBrowser(contentToRender: string) {
        if (contentToRender && contentToRender.length === 0) {
            this.router.navigateByUrl('/customerSupportInfo');
        }
        const newWindow = window.open();
        if (newWindow) {
            newWindow.document.title = this.translate('DriverRecordTitle');
            //newWindow.document.body.innerHTML = contentToRender; 
            newWindow.document.write(contentToRender);
            newWindow.document.close();
            newWindow.focus()
        }
    }
    
    isExternalFilterPresent() {
        return false;
    }

    doesExternalFilterPass(node: any) {
        if (this.searchCriteria && this.searchCriteria.searchString && this.searchCriteria.searchString.length > 0) {
            return node.data.lastName.toLowerCase().indexOf(this.searchCriteria.searchString.toLowerCase()) >= 0
                || node.data.driverLicenseNumber.toLowerCase().indexOf(this.searchCriteria.searchString.toLowerCase()) >= 0
                || node.data.driverLicenseState.toLowerCase().indexOf(this.searchCriteria.searchString.toLowerCase()) >= 0
                || node.data.userName.toLowerCase().indexOf(this.searchCriteria.searchString.toLowerCase()) >= 0;
        }
        return false;
    }


    // ********************** Formatting ********************** //
    formatDate(params: any) {
        if (params.value && params.value !== '') {
            return DateTime.fromISO(params.value).toFormat('MM/dd/yyyy');
        }
        return '';
    }

    smartSizeColumns() {
        const skipHeaders: boolean = true;
        this.gridOptions.gridApi = this.gridOptions.api;
        this.gridOptions.gridColumnApi = this.gridOptions.columnApi;
        
        const colApi = this.gridOptions.columnApi;
        const allColumnIds: number[] = [];
        if (colApi) {
            colApi.getColumns().forEach(function (column: any) {
                if (column.colId === 'dlState') {
                    if (innerWidth < 700) {
                        colApi.setColumnVisible(column.colId, false);
                    } else {
                        colApi.setColumnVisible(column.colId, true);
                    }
                }
                if (column.colId === 'dlNum') {
                    if (innerWidth < 600) {
                        colApi.setColumnVisible(column.colId, false);
                    } else {
                        colApi.setColumnVisible(column.colId, true);
                    }
                }
                if (column.colId === 'lastName') {
                    if (innerWidth < 500) {
                        colApi.setColumnVisible(column.colId, false);
                    } else {
                        colApi.setColumnVisible(column.colId, true);
                    }
                }
                allColumnIds.push(column.colId);
            });
        
            colApi.autoSizeColumns(allColumnIds, skipHeaders);
        }
        if (this.gridOptions.api) {
            this.gridOptions.api.sizeColumnsToFit();
        }
    }

    unloadMessage = function () {
        return 'You have created an account but not set up billing. Are you sure you wish to exit?';
    }

    executeCoverSheet() {
        this.modalService.dismissAll();
        this.isSubmitStatus = false;
        this.isResubmitStatus = false;
        const thisWindow = window;
        if (this.coversheetType === '') {
            return;
        }
        
        window.onbeforeunload = null;
        if (this.coversheetType === 'email') {
            this.isLoading = true;
            
            const emailLink = this.auditService.getProbationEmailLink(this.currentAuthCode)
            .then((result: any | any) => {
                this.isLoading = false;
                thisWindow.open(result, "_self");
                thisWindow.onbeforeunload = null;
            })
            .catch((error: any) => {
                console.error(error);
                thisWindow.onbeforeunload = null;
            });

            this.isLoading = false;

        } else if (this.coversheetType === 'online') {
            this.modalService.open(this.uploadModal, { size: 'lg', ariaLabelledBy: 'uploadModalTitle' });
            this.showUploadModal = true;
        } else {
            this.isLoading = true;

            const auditServicePromise = this.auditService.getFaxCoverSheet(this.currentAuthCode)
            .then((result: any | any) => {
                this.isLoading = false;
                const faxWindow = thisWindow.open('', '', 'width=800,height=600,resizable=1');
                faxWindow?.document.write(result.data);
                faxWindow?.focus();
                thisWindow.onbeforeunload = null;
            })
            .catch((error: any) => {
                console.error(error);
                thisWindow.onbeforeunload = null;
            });
            this.isLoading = false;
        }
        this.coversheetType = '';
    }

    cancelCoverSheet() {
        this.modalService.dismissAll();
        this.isSubmitStatus = false;
        this.isResubmitStatus = false;
        this.coversheetType = '';
    }

    dismissUnderReviewModal() {
        this.modalService.dismissAll();
        this.showPendingUnderReviewModal = false;
    }

    removeDocument(docId: string) {
        this.auditService.removeDocument(docId, this.currentTrans.authCode)
            .then((result: any) => {
                if (result && result === 'unauthorized') {
                    console.error('User not authorized to delete document.');
                    this.router.navigateByUrl('/accessDenied');
                } else if (result && result.length > 0) {
                    this.probationDocuments.splice(this.probationDocuments.indexOf(docId), 1);
                } else {
                    console.error('Error occurred deleting document');
                    this.router.navigateByUrl('/applicationException');
                }
            }).catch((error: any) => {
                console.error('Error deleting document.');
                console.error(error);
                this.router.navigateByUrl('/applicationException');
            });
    }

    closeUploadModal() {
        this.modalService.dismissAll();
        this.currentTrans = {};
        this.showUploadModal = false;
    }

    cancelUploads() {
        //if the upload modal is dismissed in this way we must remove the documents that may have been uploaded
        this.closeUploadModal();
        this.isLoading = true;

        this.probationDocuments.forEach((doc: any) => {
            this.auditService.removeDocument(doc.documentId, this.currentTrans.authCode);
        });
        this.probationDocuments = [];

        this.isLoading = false;
    }

    completeDocumentUploads() {
        // Update transaction status and notify CSRs if documents have been uploaded
        if (this.probationDocuments.length > 0) {
            if (this.isResubmit) {
                this.isLoading = true;
                this.auditService.updateProbationTransactionStatus(this.currentTrans.authCode, 1);
            }
            this.auditService.sendProbationUploadEmail(this.currentTrans.firstName, this.currentTrans.lastName, this.currentTrans.requestDate)
            .then((result: any) => {
                this.refreshGrid(this);
            });
        }

        this.probationDocuments = [];
        this.closeUploadModal();
    }

    showDocument(documentId: string) {
        const docUrl = `${environment.APP_API_URL}/Documents/${documentId}`;
        window.open(docUrl, '', 'width=800,height=600,resizable=1');
        //this.$viewerApi({ images: [docUrl] });
    }

    showPdfDocument(documentId: string) {
        this.pdfUrl = `${environment.APP_API_URL}/Documents/${documentId}`;
        window.open(this.pdfUrl, '', 'width=800,height=600,resizable=1');
    }

    getPDFDocumentUrl(documentId: string) {
        return `${environment.APP_API_URL}/Documents/${documentId}`;
    }

    uploadDocuments(event: any) {
        this.isValidFileType = true;
        if (event.target && event.target.files && event.target.files.length > 0) {
            Array.from(event.target.files).forEach((file: any) => {
                if (file.name) {
                    const nameParts: string[] = file.name.split('.');
                    const fileExtension = nameParts[nameParts.length - 1].toLowerCase();
                    if (fileExtension === 'pdf' || fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'jpeg') {
                        this.isValidFileType = true;
                        this.auditService.auditFiles.push(file);
                    } else {
                        this.isValidFileType = false;
                         this.invFileTypeModal = this.modalService.open(this.invalidFileTypeModal, { size: 'lg', ariaLabelledBy: 'invalidFileTypeModalTitle' });
                         event.target.value = '';
                        return;
                    }
                }
            });
        } else if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length > 0) {
            Array.from(event.dataTransfer.files).forEach((file: any) => {
                if (file.name) {
                    const nameParts: string[] = file.name.split('.');
                    const fileExtension = nameParts[nameParts.length - 1].toLowerCase();
                    if (fileExtension === 'pdf' || fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'jpeg') {
                        this.isValidFileType = true;
                        this.auditService.auditFiles.push(file);
                    } else {
                        this.isValidFileType = false;
                         this.invFileTypeModal = this.modalService.open(this.invalidFileTypeModal, { size: 'lg', ariaLabelledBy: 'invalidFileTypeModalTitle' });
                         event.target.value = '';
                        return;
                    }
                }
            });
        } else {
             // no files. User may have cancelled out of file windows file explorer when selecting file.
             event.target.value = '';
            return;
        }

        if (this.isValidFileType) {
            this.isUploading = true;
            this.auditService.uploadAuditDocuments(this.currentTrans.authCode, this.username, true)
                .then((result: any) => {
                    if (result && result === 'unauthorized') {
                         console.error('User not authorized to upload audit documents.');
                         event.target.value = '';
                        this.router.navigateByUrl('/accessDenied');
                    } else if (result && result.length > 0) {
                        result.forEach((result: any) => {
                            this.probationDocuments.push({
                                'created': result.created,
                                'creator': result.creator,
                                'documentId': result.documentId,
                                'fileName': result.fileName,
                                'mimeTypeId': result.mimeTypeId
                            });
                        });
                        this.auditService.auditFiles = [];
                         this.isUploading = false;
                         event.target.value = '';
                    }
                }).catch((error: any) => {
                    console.error('Error uploading audit documents');
                    console.error(error);
                     this.isUploading = false;
                     event.target.value = '';
                });
        } else {
             event.target.value = '';
        }
    }

    closeInvalidFileTypeModal() {
        this.isUploading = false;
        this.invFileTypeModal.close();
    }

    onFileUpload(event: any) {
    }

    translate(translationTag: string) {
        this.lang = this.translationService.getActiveLanguage().toUpperCase();

        if (translationTag === 'Voodoo' && this.gridLanguage !== this.lang as string) {
            this.gridLanguage = this.lang;
            this.populateRecords(this.startRow, this.pageSize, this.sortCol, this.sortDir);
            this.getColumnDefs().then((r) => this.loadColumnDefs(r));

            this.updateTranslatedText(this);
            this.overlayLoadingTemplate = `<span class="ag-overlay-loading-center">${this.loadingText}</span>`;
            this.overlayNoRowsTemplate = `<span><em>${this.noRowsText}</em></span>`;
            this.domLayout = 'autoHeight';
            this.defaultColDef = { resizable: true };
            
            this.smartSizeColumns();
            if (this.gridOptions.api) {
                this.gridOptions.api.setDatasource(this.rowData);
            }
            
            if(this.footerArea){
                this.generalService.gridFooterTxt(this.footerArea as ElementRef);
            }
        }
        return this.doTranslation(translationTag);
    }

    doTranslation(translationTag: string): string {
        let translatedText: string = this.generalService.getTranslation(translationTag, 'customer')
        if (translatedText === undefined) {
            translatedText = this.generalService.getTranslation(translationTag, 'customer');
        }
        return translatedText;
    }

    ngAfterViewInit(){
        const ngGridElement1 = document.querySelector<HTMLElement>('.ag-root')!;
        ngGridElement1.setAttribute('aria-busy','true');
    }

    private updateTranslatedText(scope: any) {
        if (scope.lang === 'ES'){
             scope.noRowsText = 'No se han encontrado resultados';
             scope.loadingText = 'Cargando...';
             scope.requestDateHeader = 'Fecha de solicitud';
             scope.lastNameHeader = 'Apellido';
             scope.licenseNumberHeader ='Licencia';
             scope.stateHeader = 'Estado';
             scope.actionsHeader = 'Acción';
             scope.viewButtonText = 'Ver';
             scope.expiredText = 'Caducado';
             scope.downloadButtonText = 'Descargar';
             scope.requestedByHeader = 'Solicitado por';
             scope.submitButtonText = 'Entregar';
             scope.resubmitButtonText = 'Reenviar';
             scope.pendingButtonText = 'Pendiente';
             scope.underReviewButtonText = 'En Revisión';
        } else if (scope.lang === 'FR') {
             scope.noRowsText = 'Aucun résultat trouvé';
             scope.loadingText = 'Chargement...';
             scope.requestDateHeader = 'Date de la demande';
             scope.lastNameHeader = 'Nom de famille';
             scope.licenseNumberHeader ='Numéro de permis';
             scope.stateHeader = 'État';
             scope.actionsHeader = 'Action';
             scope.viewButtonText = 'Afficher';
             scope.expiredText = 'Expiré';
             scope.downloadButtonText = 'Télécharger';
             scope.requestedByHeader = 'Demandé par';
             scope.submitButtonText = 'Soumettre';
             scope.resubmitButtonText = 'Soumettre à nouveau';
             scope.pendingButtonText = 'En instance';
             scope.underReviewButtonText = 'En procès de vérification';
        } else {
             scope.noRowsText = 'No results found';
             scope.loadingText = 'Loading...';
             scope.requestDateHeader = 'Request Date';
             scope.lastNameHeader = 'Last Name';
             scope.licenseNumberHeader = 'License #';
             scope.stateHeader = 'State';
             scope.actionsHeader = 'Actions';
             scope.viewButtonText = 'View';
             scope.expiredText = 'Expired';
             scope.downloadButtonText = 'Download';
             scope.requestedByHeader = 'Requested By';
             scope.submitButtonText = 'Submit';
             scope.resubmitButtonText = 'Resubmit';
             scope.pendingButtonText = 'Pending';
             scope.underReviewButtonText = 'Under Review';
        }
   }
}
